// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SJvC","name":"styles_name__2PgY2","phone":"styles_phone__1h8d5"};